import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {getEnvApi} from "../../api";

export const baseQuery = fetchBaseQuery({
    baseUrl: getEnvApi(),
    prepareHeaders: (headers) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            headers.set('Authorization', `Bearer ${token}`)
        } else {
            headers.set('Authorization', 'NO HEADER')
        }
        return headers
    },
});

export const baseApi = createApi({
    reducerPath: 'baseApi',
    baseQuery: baseQuery,
    tagTypes: ['doctor', 'appointment',
        'feedback', 'appointment_times',
        'appointment_times_address', 'daily_reconciliations',
        'reconciliations','header'],
    endpoints: () => ({}),
})
